<template>
<modal name="format-detail" height="auto" :width="480" :pivotX="0" :pivotY=".15" @before-open="fetchFormat" @before-close="beforeClose">

  <aside class="window format-detail">
    <header class="window__header">
      <h1 class="window__title"><strong class="window__title__strong">{{ format.name }}</strong> </h1><br>
      <h2 v-if="format.premium" class="window__description"><strong><i>Premium Ad Format</i></strong></h2>
    </header>

<!--
    <section class="window__content">
      <ul class="image-slider">
        <li class="image-slider__item">
          <a href="#">
            <figure class="photo">
              <img class="photo__source" src="https://static.politico.com/dims4/default/060e817/2147483647/resize/1160x%3E/quality/90/?url=https%3A%2F%2Fstatic.politico.com%2F51%2F13%2F6f2a61144f4483d66ac7b150d0df%2F17-donald-trump-92-gty-1160.jpg" />
              <figcaption class="photo__layover">
                <span class="photo__view">View demo</span>
              </figcaption>
            </figure>
          </a>
        </li>

        <li class="image-slider__item">
          <a href="#">
            <figure class="photo">
              <img class="photo__source" src="https://static.politico.com/dims4/default/060e817/2147483647/resize/1160x%3E/quality/90/?url=https%3A%2F%2Fstatic.politico.com%2F51%2F13%2F6f2a61144f4483d66ac7b150d0df%2F17-donald-trump-92-gty-1160.jpg" />
              <figcaption class="photo__layover">
                <span class="photo__view">View demo</span>
              </figcaption>
            </figure>
          </a>
        </li>

        <li class="image-slider__item">
          <a href="#">
            <figure class="photo">
              <img class="photo__source" src="https://static.politico.com/dims4/default/060e817/2147483647/resize/1160x%3E/quality/90/?url=https%3A%2F%2Fstatic.politico.com%2F51%2F13%2F6f2a61144f4483d66ac7b150d0df%2F17-donald-trump-92-gty-1160.jpg" />
              <figcaption class="photo__layover">
                <span class="photo__view">View demo</span>
              </figcaption>
            </figure>
          </a>
        </li>
      </ul>
    </section>
-->
    <footer class="window__footer">
      <span data-v-long-step="6" class="window__button button button--primary button--large" v-on:click="useFormat">Use format</span>
      <span class="window__link link link--secondary" v-on:click="hide">Cancel</span>
    </footer>
  </aside>

</modal>
</template>

<script>

export default {
  name: 'FormatDetailModal',
  methods: {
    fetchFormat (event) {
      this.format = this.$store.getters['formats/formats'].filter((format) => {
        return parseInt(event.params.id, 10) === format.id
      })[0]
    },
    beforeClose (event) {
      this.previousTourStep();
    },
    previousTourStep () {
      if (this.$tours['long_tour'].currentStep === 6) {
        this.$tours['long_tour'].previousStep();
      }
    },
    hide () {
      this.previousTourStep();
      this.$modal.hide('format-detail')
    },
    useFormat () {
      if (this.$tours['long_tour'].currentStep === 6) {
        this.$tours['long_tour'].nextStep();
      }
      this.$modal.hide('format-detail')
      this.$router.push({
        path: `/configuration/${this.format.id}`
      })
    }
  },
  data () {
    return {
      format: {
        title: null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/FormatDetail.vue